import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PostInsightsContent from 'modules/posts/components/PostInsightsContent'
import { useParams } from 'react-router-dom'

const PostInsightsPage = () => {
  const id = useParams().id ?? ''

  return (
    <ResponsivePage.Body>
      <PostInsightsContent postId={id} />
    </ResponsivePage.Body>
  )
}

export default PostInsightsPage
